<template>
  <div :class="cssClass">
    <div class="c-advice__image">
      <img :src="require('@/assets/img/img-advice-' + img + '.svg')" alt="" />
    </div>
    <div class="c-advice__inner">
      <div v-if="$slots.title" class="c-advice__title">
        <slot name="title"></slot>
      </div>
      <div v-if="$slots.default" class="c-advice__content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    img: {
      type: String,
      required: false,
      default: 'pencil'
    },
    priority: {
      type: String,
      required: false,
      default: 'normal'
    }
  },
  computed: {
    cssClass() {
      return {
        'c-advice': true,
        ['c-advice--' + this.priority]: this.priority
      };
    }
  }
};
</script>
